const bucketS3 = `https://dq-moneygram.s3.eu-central-1.amazonaws.com`;

export const ImagesConfig = {
  loginBackground: {
    alt: 'Imagen de fondo',
    src: `${bucketS3}/images/laptop-background.png`,
  },

  logo: {
    alt: 'Logo Moneygram',
    src: `${bucketS3}/logos/MoneyGram_Logo.svg`,
  },

  avatar: {
    src: `${bucketS3}/images/avatar-img.png`,
    alt: 'Avatar',
  },

  bars: {
    src: `${bucketS3}/icons/Bars-icon.svg`,
    alt: 'Bar Icon',
  },
};
